<template>
  <VCard class="elevation-12">
    <VToolbar
      dark
      color="primary"
    >
      <VToolbarTitle>Change Password</VToolbarTitle>
    </VToolbar>
    <VCardText>
      <VForm
        ref="requestForm"
        v-model="requestForm"
        @submit="handleRequest"
      >
        <VTextField
          v-model="email"
          :rules="emailRules"
          prepend-icon="email"
          name="email"
          label="Email"
          type="text"
        />
        <VCardActions>
          <VSpacer />
          <VBtn
            :loading="loading"
            :disabled="!requestForm"
            color="primary"
            type="submit"
            @click.prevent="handleRequest"
          >
            Send
          </VBtn>
        </VCardActions>
      </VForm>
    </VCardText>
    <NetworkSnackBar />
  </VCard>
</template>

<script>
import { mapGetters } from 'vuex'
import NetworkSnackBar from './NetworkSnackBar'
export default {
  name: 'ResetPasswordRequestCard',
  components: { NetworkSnackBar },
  data: function () {
    return {
      requestForm: false,
      email: '',
      emailRules: [
        v => !!v || 'Required.',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ]
    }
  },
  computed: {
    ...mapGetters({
      loading: 'account/getResetPasswordLoading'
    })
  },
  methods: {
    handleRequest () {
      const { email } = this
      const { dispatch } = this.$store
      if (this.$refs.requestForm.validate()) {
        dispatch('alert/clear')
          .then(() => dispatch('account/resetPassword',
            { email }
          ))
      }
    }
  }
}
</script>

<style scoped>

</style>
